<template>
  <div class="list-page">
    <!-- 蓝色头部：图标 + 主标题 + 副标题（统一放入 banner） -->
    <div class="detail-banner">
      <div class="container">
        <div class="os-banner">
          <img v-if="icon" :src="icon" class="os-banner-icon" @error="onImgError" alt="" />
          <div class="os-banner-text">
            <h1>{{ bannerTitle }}</h1>
            <p v-if="subtitle" class="os-banner-sub">{{ subtitle }}</p>
          </div>
        </div>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div v-if="loading" class="empty-block">加载中…</div>

        <div v-else-if="pageData" class="os-info">
          <!-- 内容章节（标题已收入 banner，此处不再重复显示） -->
          <div class="os-sections" v-if="pageData.data && pageData.data.length">
            <div class="os-section" v-for="(sec, si) in pageData.data" :key="si">
              <div class="os-section-title" v-if="sec.title">{{ sec.title }}</div>
              <div class="os-section-sub" v-if="sec.subtitle">{{ sec.subtitle }}</div>

              <div class="os-data" v-if="sec.data && sec.data.length">
                <div class="os-data-item" v-for="(d, di) in sec.data" :key="di">
                  <div class="os-data-title" v-if="d.title">{{ d.title }}</div>
                  <div class="os-data-content" v-if="d.content">{{ d.content }}</div>
                </div>
              </div>

              <div class="os-list" v-if="sec.list && sec.list.length">
                <div class="os-list-item" v-for="(l, li) in sec.list" :key="li">
                  <span class="os-list-dot"></span>
                  <span class="os-list-text" v-if="l.content">{{ l.content }}</span>
                  <span class="os-list-text" v-else-if="l.title">{{ l.title }}</span>
                </div>
              </div>

              <div class="os-img-wrap" v-if="sec.image">
                <img :src="sec.image" class="os-section-img" @error="onImgError" />
              </div>
            </div>
          </div>

          <div class="os-contact">
            <button class="os-contact-btn" @click="consult">立即咨询</button>
          </div>
        </div>

        <div v-else class="empty-block">内容加载失败，请重试</div>
      </div>
    </section>
  </div>
</template>

<script>
import { getJson } from '../api/request'
import { WECHAT_WORK_CONSULT_URL } from '../config/site'

export default {
  name: 'OverseaServiceInfo',
  data () {
    return {
      pageData: null,
      title: '服务详情',
      icon: '',
      loading: true
    }
  },
  computed: {
    bannerTitle () {
      return (this.pageData && this.pageData.title) ? this.pageData.title : this.title
    },
    subtitle () {
      return (this.pageData && this.pageData.subtitle) ? this.pageData.subtitle : ''
    }
  },
  created () {
    this.title = this.$route.query.title || '服务详情'
    this.load()
  },
  methods: {
    async load () {
      const json = this.$route.query.json
      if (!json) {
        this.loading = false
        return
      }
      this.loading = true
      try {
        const data = await getJson(json)
        this.pageData = data.data || null
        this.icon = this.pageData ? this.pageData.icon : ''
      } catch (e) {
        this.pageData = null
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    consult () {
      window.open(WECHAT_WORK_CONSULT_URL, '_blank', 'noopener')
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
/* banner 内：图标 + 标题 + 副标题 横向排列 */
.os-banner {
  display: flex;
  align-items: center;
  gap: 18px;
}
.os-banner-icon {
  width: 76px;
  height: 76px;
  border-radius: 18px;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
}
.os-banner-text {
  min-width: 0;
}
.os-banner-text h1 {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin: 0;
  line-height: 1.3;
}
.os-banner-sub {
  margin: 8px 0 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.92);
  line-height: 1.6;
}

.os-section {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: var(--shadow);
  padding: 24px 26px;
  margin-bottom: 18px;
}
.os-section-title {
  font-size: 18px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 10px;
}
.os-section-sub {
  font-size: 14px;
  color: var(--text-sub);
  line-height: 1.7;
  margin-bottom: 12px;
}
.os-data {
  border-top: 1px dashed var(--border);
  padding-top: 12px;
}
.os-data-item {
  padding: 12px 0;
  border-bottom: 1px solid rgba(36, 68, 203, 0.08);
}
.os-data-item:last-child {
  border-bottom: none;
}
.os-data-title {
  font-size: 15.5px;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 6px;
}
.os-data-content {
  font-size: 14px;
  color: var(--text-sub);
  line-height: 1.8;
}
.os-list {
  border-top: 1px dashed var(--border);
  padding-top: 12px;
}
.os-list-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 9px 0;
  font-size: 14px;
  color: var(--text-sub);
  line-height: 1.7;
}
.os-list-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--primary);
  margin-top: 8px;
  flex-shrink: 0;
}
/* 图片展示优化：统一居中、限宽、圆角描边，避免大图撑满不和谐 */
.os-img-wrap {
  margin-top: 14px;
  text-align: center;
}
.os-section-img {
  display: inline-block;
  max-width: 100%;
  max-height: 420px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}
.os-contact {
  text-align: center;
  margin-top: 26px;
}
.os-contact-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  padding: 13px 38px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.os-contact-btn:hover {
  opacity: 0.9;
}
</style>
